export default __webpack_public_path__ + "static/media/soberRewards.a25befe7.webp";